import { combineReducers } from "redux";
import alertReducer from "./alertReducer";
import menuReducer from "./menuReducer";
import globalErrorReducer from "./globalErrorReducer";

const reducers = combineReducers({
  alert: alertReducer,
  menu: menuReducer,
  globalError: globalErrorReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
